import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { GET_PLACE_PREDICTIONS } from '../../queries/get-place-predictions.js';
import fromQueryPlacePredictionsToPlacePredictions from './adapters/fromQueryPlacePredictionsToPlacePredictions.js';

const usePlacePredictions = (options)=>{
    const [query, queryState] = useLazyQuery(GET_PLACE_PREDICTIONS, swcHelpers.objectSpread({}, options));
    const data = React__default.useMemo(()=>{
        var ref;
        return fromQueryPlacePredictionsToPlacePredictions((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.placePredictions);
    }, [
        queryState.data
    ]);
    return React__default.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};
var usePlacePredictions$1 = usePlacePredictions;

export { usePlacePredictions$1 as default };
//# sourceMappingURL=use-place-predictions.js.map
